"use client";
import { StartAsPage, SwitchCallbackMouseEvent } from "../types";
import React from "react";
import ResetPasswordRequestForm from "./ResetPasswordRequestForm";
import ResetPasswordConfirmForm from "../Forms/ResetPasswordConfirmForm";

interface PasswordRecoveryFormsProps {
  currentPage: StartAsPage;
  switchToLogin: (
    e: SwitchCallbackMouseEvent,
    showCompletedMessage: boolean,
    skipReplaceBase: boolean,
  ) => void;
  isModal?: boolean;
}

function PasswordRecoveryForms({
  currentPage,
  switchToLogin,
  isModal = false,
}: PasswordRecoveryFormsProps) {
  const formComponent =
    currentPage === StartAsPage.ForgotPassword ? (
      <ResetPasswordRequestForm isModal={isModal} />
    ) : currentPage === StartAsPage.ForgotPasswordConfirm ? (
      <ResetPasswordConfirmForm
        onResetCompleted={(e) => switchToLogin(e, true, isModal)}
      />
    ) : null;

  return (
    <div className="w-full md:max-w-[628px]">
      <div className="w-full">{formComponent}</div>
    </div>
  );
}

export default PasswordRecoveryForms;
